import { injectReducer } from 'src/state';
import { RootState } from 'src/state/reducer';
import {
  courseBundleElearningsReducer,
  CourseBundleElearningsState,
} from 'src/courseBundle/state/courseBundleElearnings/courseBundleElearningsReducer';
import {
  courseBundleEventsReducer,
  CourseBundleEventsState,
} from 'src/courseBundle/state/courseBundleEvents/courseBundleEventsReducer';

export const injectCourseBundleElearningsPageState = () => {
  injectReducer('courseBundleElearnings', courseBundleElearningsReducer);
};

export interface CourseBundleElearningsPageState extends RootState {
  courseBundleElearnings: CourseBundleElearningsState;
}

export const injectCourseBundleEventsPageState = () => {
  injectReducer('courseBundleEvents', courseBundleEventsReducer);
};

export interface CourseBundleEventsPageState extends RootState {
  courseBundleEvents: CourseBundleEventsState;
}
